export const AD_ACCOUNT_NOT_SELECTED =
  'Please go to the settings page to link an ad account.';
export const SUCCESSFUL_SYNC = 'All Changes Synced';
export const LINK_AD_ACCOUNT = 'Link Ad Account';
